import React, { Component } from "react";
import {LabelTestTube} from '@learningblocks/storybook-components';
import { findIndex } from "lodash"


export class LabelTubes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      complete: false,
      samples: null
    };
  }


  componentWillMount(){
    this.setState({ samples: this.props.labelTubeSamples })
  }

  onDropdownChange = (selectedSample)=>{
    const { samples } = this.state;
    const sample  = samples[findIndex(samples, { id: selectedSample.sampleId })];

    sample.currentValue = selectedSample.value
    sample.showFeedback = selectedSample.value === selectedSample.actualValue;

    samples[findIndex(samples, { id: selectedSample.sampleId })] = sample;

    this.setState({ samples })
  }

  allTubesRenamed(){
    let samples = this.state.samples
    let renamed = true;
    for (let i = 0; i < samples.length; i++) {
      let sample = samples[i];
      if(sample.currentValue == null || (sample.currentValue !== sample.actualValue)){
        renamed = false;
        sample.showFeedback = true
      }else{
        sample.showFeedback = false
      }
    }

    if(!renamed){
      this.setState({ samples })
    }
    return renamed
  }

  onSubmitLabelChaanges = () =>{
    const renamed = this.allTubesRenamed();
    if(!renamed){
      console.log('onSubmit : some are still to be renamed');
      return
      
    }
    this.props.labelReactionTubes({ labelReactionTubes: true })
    this.props.showModal({ display: false });
    console.log('onSubmit : all good');

  }

  render() {
    return (
          <div style={{background:"#fff"}}>
          <LabelTestTube 
                label= 'LABEL THE TUBES'
                complete= {this.state.complete}
                question=
                  'Label each of your digest tubes with the number for the PCR sample and a + symbol to indicate that restriction enzyme will be added.'
                samples= {this.state.samples}
                onDropdownChange={this.onDropdownChange}
                onSubmit={this.onSubmitLabelChaanges}
          />
          </div>
    );
  }

}
